export const canvasActionType = {
  addSection: "AddSection",
  addSections: "AddSections",
  updateSection:"UpdateSection",  
  addFieldsToSection: "AddFieldsToSection",
  removeSection: "RemoveSection",
  replaceSection : "ReplaceSection"
};
